<template lang="pug">
    div(class="caption font-weight-bold primary--text") Open / Closed
        v-radio-group(dense v-model="open" @change="onSelect" :readonly="readonly")
            v-radio(label="Open" :value="true" color="primary" )
            v-radio(label="Closed" :value="false" color="primary")
</template>
<script>
export default {
    name: "FRadioVirtualAccountOpen",
    props: ["value","readonly"],
    data() {
        return {
            open: null
        };
    },
    mounted() {
        this.doInitModel(this.value);
    },
    watch: {
        value(val) {
            this.doInitModel(val);
        }
    },
    methods: {
        doInitModel(values) {
            this.open = values;
            this.onSelect();
        },
        onSelect() {
            this.$emit("input", this.open);
            this.$emit("select", this.open);
        }
    }
};
</script>